export default "__VITE_ASSET__jH6JV9xR__"